import React from 'react';
import { PageIntro } from '../components/PageIntro';
import { StorySection } from '../components/about/StorySection';
import { PrinciplesSection } from '../components/about/PrinciplesSection';
import { HowWeWork } from '../components/about/HowWeWork';
import { TeamSection } from '../components/about/TeamSection';
import { CapabilitiesSection } from '../components/about/CapabilitiesSection';
import { NumbersStrip } from '../components/home/NumbersStrip';
import { CtaBand } from '../components/home/CtaBand';
import { positioning } from '../data/about';
import { aboutHeroImage } from '../data/aboutImages';
export function About() {
  return <>
      <PageIntro eyebrow={positioning.eyebrow} title={positioning.title} lede={positioning.lede} image={{
      src: aboutHeroImage.image,
      alt: aboutHeroImage.alt
    }} data-id="element-915" data-mp="2s9v3zbfceqj7" />
      <NumbersStrip data-id="element-916" data-mp="1gtn3dfjh1pa6" />
      <StorySection data-id="element-917" data-mp="1lu19ut5fcr63" />
      <PrinciplesSection data-id="element-918" data-mp="1lukifj96q37g" />
      <HowWeWork data-id="element-919" data-mp="1luu9zb9voif9" />
      <TeamSection data-id="element-920" data-mp="1lvcdmsyvdyx7" />
      <CapabilitiesSection data-id="element-921" data-mp="1lrokvw191gjj" />
      <CtaBand data-id="element-922" data-mp="1uha0xkg2fate" />
    </>;
}